/*
 * 订单管理
 */

import EmptyRouter from '@/layout/EmptyRouter.vue';
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';
// import Test0Empty from '@/views/test/empty.vue';
export default {
  path: 'csgOrder',
  name: 'BusinessOrder',
  component: EmptyRouterAlive,
  meta: {
    title: '普通订单',
  },
  children: [
    // 内部订单
    {
      path: 'internal',
      name: 'BusinessOrderInternal',
      component: EmptyRouter,
      redirect: 'internal/index',
      meta: {
        title: '内部订单',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessOrderInternal',
          component: () => import('@/views/center-business/csgOrder/internal/index'),
          meta: {
            title: '内部订单',
            isCache: true
          },
        },
      ],
    },
    // 待审核销售单
    {
        path: 'audit',
        name: 'BusinessOrderAudit',
        component: EmptyRouter,
        redirect: 'audit/index',
        meta: {
          title: '待审核销售单',
        },
        children: [
          {
            path: 'index',
            name: 'BusinessOrderAudit',
            component: () => import('@/views/center-business/csgOrder/audit/index'),
            meta: {
              title: '待审核销售单',
              isCache: true
            },
          },
          /** 按钮权限start */
          {
            path: '',
            name: 'BusinessOrderAuditIndex_SourceFirst',
            meta: { title: '寻源前一审' },
            hidden: true,
          },
          {
            path: '',
            name: 'BusinessOrderAuditIndex_SourceSecond',
            meta: { title: '寻源前二审' },
            hidden: true,
          },
          {
            path: '',
            name: 'BusinessOrderAuditIndex_PreemptFirst',
            meta: { title: '发货前一审' },
            hidden: true,
          },
          {
            path: '',
            name: 'BusinessOrderAuditIndex_PreemptSecond',
            meta: { title: '发货前二审' },
            hidden: true,
          },
          /** 按钮权限end */
        ],
    },
    // 预占管理
    {
        path: 'preempt',
        name: 'BusinessOrderPreempt',
        component: EmptyRouter,
        redirect: 'preempt/index',
        meta: {
          title: '预占管理',
        },
        children: [
          {
            path: 'index',
            name: 'BusinessOrderPreempt',
            component: () => import('@/views/center-business/csgOrder/preempt'),
            meta: {
              title: '预占管理',
              isCache: true
            },
          },
          {
            path: 'view',
            name: 'BusinessOrderPreemptView',
            component: () => import('@/views/center-business/csgOrder/preempt/view'),
            meta: {
              title: '预占详情',
            },
            hidden: true,
          },
        ],
    },
    // 物流下单
    {
      path: 'BookLogistic',
      name: 'BusinessOrderBookLogistic',
      component: EmptyRouter,
      redirect: 'BookLogistic/index',
      meta: {
        title: '物流下单',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessOrderBookLogistic',
          component: () => import('@/views/center-business/csgOrder/BookLogistic'),
          meta: {
            title: '物流下单',
            isCache: true
          },
        },
      ],
    },
    // 寻源管理
    {
        path: 'source',
        name: 'BusinessOrderSource',
        component: EmptyRouter,
        redirect: 'source/list',
        meta: {
          title: '寻源管理',
        },
        children: [
          {
            path: 'list',
            name: 'BusinessOrderSource',
            component: () => import('@/views/center-business/csgOrder/source/index'),
            meta: {
              title: '寻源管理',
              isCache: true
            },
          },
          {
            path: 'detail',
            name: 'BusinessOrderSourceView',
            component: () => import('@/views/center-business/csgOrder/source/view'),
            meta: {
              title: '寻源详情',
            },
            hidden: true,
          },
          {
            path: '',
            name: 'BusinessOrderSourceIndex_AssignStore',
            meta: {
              title: '指定发货-寻源管理',
            },
            hidden: true,
          },
          {
            path: '',
            name: 'BusinessOrderSourceIndex_AfreshSource',
            meta: {
              title: '重新寻源-寻源管理',
            },
            hidden: true,
          },
          {
            path: '',
            name: 'BusinessOrderSourceIndex_Log',
            meta: {
              title: '日志-寻源管理',
            },
            hidden: true,
          },
        ],
    },
    {
        path: 'abnormalOrders',
        name: 'BusinessAbnormalOrderIndex',
        component: EmptyRouter,
        redirect: 'abnormalOrders/all',
        meta: {
          title: '未完成订单',
        },
        children: [
          {
            path: 'all',
            name: 'BusinessAbnormalOrderALL',
            component: () => import('@/views/center-business/csgOrder/abnormalOrders/all'),
            meta: {
              title: '全部订单',
              isCache: true
            },
            permissionType: 'tab',
            hidden: true,
          },
          {
            path: 'stock',
            name: 'BusinessAbnormalOrderSTOCK',
            component: () => import('@/views/center-business/csgOrder/abnormalOrders/stock'),
            meta: {
              title: '新订单',
              isCache: true
            },
            permissionType: 'tab',
            hidden: true,
          },
          {
            path: 'processing',
            name: 'BusinessAbnormalOrderPROCESSINGOrder',
            component: () => import('@/views/center-business/csgOrder/abnormalOrders/processing'),
            meta: {
              title: '处理中订单',
              isCache: true
            },
            permissionType: 'tab',
            hidden: true,
          },
          {
            path: 'anomaly',
            name: 'BusinessAbnormalOrderANOMALY',
            component: () => import('@/views/center-business/csgOrder/abnormalOrders/anomaly'),
            meta: {
              title: '异常订单',
              isCache: true
            },
            permissionType: 'tab',
            hidden: true,
          },
          {
            path: 'outOfStock',
            name: 'BusinessAbnormalOrderOUTOFSTOCK',
            component: () => import('@/views/center-business/csgOrder/abnormalOrders/outOfStock'),
            meta: {
              title: '缺货订单',
              isCache: true
            },
            permissionType: 'tab',
            hidden: true,
          },
          {
            path: 'WaitingShipped',
            name: 'BusinessAbnormalOrderWAIRING',
            component: () => import('@/views/center-business/csgOrder/abnormalOrders/WaitingShipped'),
            meta: {
              title: '等待发货',
              isCache: true
            },
            permissionType: 'tab',
            hidden: true,
          },
          {
            path: 'collectPending',
            name: 'BusinessAbnormalOrderCOLLECTPENDING',
            component: () => import('@/views/center-business/csgOrder/abnormalOrders/collectPending'),
            meta: {
              title: '等待取货',
              isCache: true
            },
            permissionType: 'tab',
            hidden: true,
          },
          {
            path: 'collectPendingLabel',
            name: 'BusinessAbnormalOrderCOLLECTPENDINGLabel',
            component: () => import('@/views/center-business/csgOrder/abnormalOrders/collectPendingLabel'),
            meta: {
              title: '已上传面单',
              isCache: true
            },
            permissionType: 'tab',
            hidden: true,
          },
          {
            path: 'PendingHJCancel',
            name: 'BusinessAbnormalOrderPendingHJCancel',
            component: () => import('@/views/center-business/csgOrder/abnormalOrders/PendingHJCancel'),
            meta: {
              title: '待HJ取消',
              isCache: false
            },
            permissionType: 'tab',
            hidden: true,
          },
          {
            path: 'Urgent',
            name: 'BusinessAbnormalOrderUrgent',
            component: () => import('@/views/center-business/csgOrder/abnormalOrders/Urgent'),
            meta: {
              title: '加急',
              isCache: false
            },
            permissionType: 'tab',
            hidden: true,
          },
          {
            path: 'waitHUNT',
            name: 'BusinessAbnormalOrderHUNT',
            component: () => import('@/views/center-business/csgOrder/abnormalOrders/waitHunt'),
            meta: {
              title: '待手动取消',
              isCache: true
            },
            permissionType: 'tab',
            hidden: true,
          },
          {
            path: 'exception',
            name: 'BusinessAbnormalOrderEXCEPTION',
            component: () => import('@/views/center-business/csgOrder/abnormalOrders/exception'),
            meta: {
              title: '推送异常',
              isCache: true
            },
            permissionType: 'tab',
            hidden: true,
          },
          {
            path: 'timeout',
            name: 'BusinessAbnormalOrderTIMEOUT',
            component: () => import('@/views/center-business/csgOrder/abnormalOrders/timeout'),
            meta: {
              title: '预占超时',
              isCache: true
            },
            permissionType: 'tab',
            hidden: true,
          },
          // 订单列表
          {
            path: 'order/orderListDetail',
            name: 'BusinessThirdOrderCSGView',
            component: () => import('@/views/center-business/csgOrder/order/orderListDetail'),
            meta: {
              title: '订单列表详情',
            },
            hidden: true,
          },
          {
            path: 'order/addThirdOrder',
            name: 'BusinessAddThirdOrderCSGView',
            component: () => import('@/views/center-business/csgOrder/order/addThirdOrder'),
            meta: {
              title: '新增订单列表',
              isCache: true
            },
            hidden: true,
          },

          {
            path: 'order/copyOrder',
            name: 'BusinessOrderInternalAddCSG',
            component: () => import('@/views/center-business/csgOrder/order/copyOrder'),
            meta: {
              title: '复制订单',
              isCache: true,
            },
            hidden: true,
          },
          {
            path: 'orderEdit',
            name: 'BusinessOrderInternalEditCSG',
            component: () => import('@/views/center-business/csgOrder/order/orderEdit'),
            meta: {
              title: '订单编辑',
              isCache: true,
            },
            hidden: true,
          },
        ],
    },
    // 订单处理 CSGAdmin版
    {
        path: 'orderProcessing',
        name: 'BusinessOrderInternalCSGAdmin',
        component: EmptyRouter,
        redirect: 'orderProcessing/index',
        meta: {
          title: '已完成订单',
        },
        children: [
          {
            path: 'index',
            name: 'BusinessOrderInternalCSGAdmin',
            component: () => import('@/views/center-business/csgOrder/orderProcessing/index'),
            meta: {
              title: '订单处理',
              isCache: true
            },
          },
          {
            path: 'detail',
            name: 'BusinessOrderInternalViewCSG',
            component: () => import('@/views/center-business/csgOrder/orderProcessing/detail'),
            meta: {
              title: '订单处理详情',
            },
            hidden: true,
          },
          {
            path: 'feeInfoTab',
            name: 'BusinessOrderInternalCSGFEE',
            component: () => import('@/views/center-business/csgOrder/feeInfoTab'),
            meta: {
              title: '费用信息',
            },
            hidden: true,
          },
        ],
      },

      {
        path: 'deliveryNote',
        name: 'BusinessBillingDeliveryNote',
        component: EmptyRouter,
        redirect: 'deliveryNote/index',
        meta: {
          title: '发货单',
        },
        children: [
          {
            path: 'index',
            name: 'BusinessBillingDeliveryNote',
            component: () => import('@/views/center-business/billing/deliveryNote'),
            meta: {
              title: '发货单',
              isCache: true,
            }
          },
          {
            path: 'add',
            name: 'BusinessBillingAddDeliveryNote',
            component: () => import('@/views/center-business/billing/deliveryNote/add'),
            meta: {
              title: '新增发货单',
              isCache: true,
            }
          },
        ],
      },
      {
        path: 'serviceItem',
        name: 'BusinessBillingServiceItem',
        component: EmptyRouter,
        redirect: 'serviceItem/index',
        meta: {
          title: '订单托盘配置',
        },
        children: [
          {
            path: 'index',
            name: 'BusinessBillingServiceItem',
            component: () => import('@/views/center-business/csgOrder/serviceItem'),
            meta: {
              title: '订单托盘配置',
              isCache: true,
            }
          },
        ],
      },
  ],
};
